import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {ContentModule} from "../../../../shared/directives/content.module";
import {MultipleSelectFilterSimpleComponent} from "./multiple-select-filter-simple.component";
import {MultipleSelectFilterModule} from "../multiple-select-filter/multiple-select-filter.module";

@NgModule({
    declarations: [
        MultipleSelectFilterSimpleComponent,
    ],
    exports: [
        MultipleSelectFilterSimpleComponent,
    ],
    imports: [
        ReactiveFormsModule,
        FormsModule,
        CommonModule,
        ContentModule,
        MultipleSelectFilterModule
    ]
})
export class MultipleSelectFilterSimpleModule {
}
